module.exports = __webpack_public_path__ + "img/bank_icon_update_v2.05a9eea5.png";